import { Component, Input, OnInit, OnDestroy, Inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { FileViewExplorerComponent } from "src/app/file-view-explorer/file-view-explorer.component";
import { CommonService } from "src/app/services/common.service";
import { TabChangeService } from "src/app/services/tab-change.service";
import { ModalTabVisibilityService } from '../../services/modal-tab-visibility.service';
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
@Component({
  selector: "app-casehistory",
  templateUrl: "./casehistory.component.html",
  styleUrls: ["./casehistory.component.scss"],
})
export class CasehistoryComponent implements OnInit, OnDestroy {
  //@Input() casehistory = [];
  PatientHistory: any[] = [];
  deploymentKey:string='';
  islabadmin:boolean = false;
  
  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'case 360 prime';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];
  
  constructor(
    private service: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    @Inject('caseData') public casehistory: any,
    private tabChangeService: TabChangeService,
    private modalTabVisibility: ModalTabVisibilityService
  ) {}
  ngOnInit() {
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-case360-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    
    this.getCaseHistory();
  }
  
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }
  async getCaseHistory() {
    this.islabadmin=this.casehistory['islabadmin'];
    if (this.casehistory.patientHistory.length > 0) {
      this.PatientHistory = [];
      this.deploymentKey=this.casehistory.deployment;
      // Step 1: Collect all data objects and all PatientHistory arrays
      let allDataObjects = [];
      let combinedPatientHistory = [];
      
      for (let i = 0; i < this.casehistory.patientHistory.length; i++) {
        let obj = {
          CaseGuid: this.casehistory.patientHistory[i].CaseGuid,
          DeploymentKey: this.deploymentKey,
        };
        this.ngxUiLoaderService.start();
        let data=await this.service.postapi('api/Case360/GetCaseXML',obj);
        
        // Collect PatientHistory from each data object and combine into one array
        let patientHistoryList = data['Case'] && data['Case']['PatientHistoryDetails'] && data['Case']['PatientHistoryDetails']['PatientHistory'];
        if(patientHistoryList && Array.isArray(patientHistoryList) && patientHistoryList.length > 0) {
          combinedPatientHistory = combinedPatientHistory.concat(patientHistoryList);
        }
        
        // Store the data object for later processing
        allDataObjects.push(data);
        this.ngxUiLoaderService.stop();
      }
      
      // Step 2: Loop through combined PatientHistory array and update each data object
      for (let j = 0; j < allDataObjects.length; j++) {
        let data = allDataObjects[j];
        let currentCaseGuid = data['Case']['CaseGUID'] || data['Case']['CaseGuid'];
        let currentAccession = data['Case']['AccessionNumber'];
        
        // Find matching entry in combined PatientHistory array
        let patienthistoryobj = combinedPatientHistory.find(x => 
          (x.CaseGuid && currentCaseGuid && x.CaseGuid.toLowerCase() === currentCaseGuid.toLowerCase()) ||
          (x.Accession && currentAccession && x.Accession === currentAccession)
        );
        
        if(patienthistoryobj != undefined) {
          data['Case']['SignOutDate'] = patienthistoryobj['SignOutDate'];
          data['Case']['RequisitionNumber'] = patienthistoryobj['RequisitionNumber'];
          if(patienthistoryobj['LastDistributionStatus']) {
            data['Case']['LastDistributionStatus'] = patienthistoryobj['LastDistributionStatus'];
          }
        }
        
        this.PatientHistory.push(data);
      }
      console.log(this.PatientHistory);
      if(this.PatientHistory.length>0){
        this.service.auditsave("View","","Viewed patient history details","case",
        this.casehistory["CaseGuid"],"Patient history tab ,deployment key :-" + this.deploymentKey
      );
    }
    } else {
      this.PatientHistory = [];
        this.toastr.warning(
          "No Patient History Found",
          "",
          {
            positionClass: "toast-bottom-right",
            timeOut: 4000,
          }
        );
    }
  }

  viewCase(item: object) {
    let obj = {
      ...this.service.CaseDataDetails,
      casedata: JSON.stringify(item),
    };
    this.service.updateCaseXMLToComponent(JSON.stringify(obj));
  }

  showRequReport(caseData: any) {
    if(caseData.Attachments==null){
      this.toastr.warning("No Requisition Report Found", "Alert", {
        positionClass: "toast-bottom-right",
        timeOut: 2000,
      });
    }
    else if (typeof caseData.Attachments.File === "object") {
      this.viewCaseFile(caseData.Attachments.File, caseData);
    } else if (Array.isArray(caseData.Attachments.File)) {
      let datas = caseData.Attachments.File.filter(
        (va) => va.Category === "Requisition"
      );
      if (datas.length > 0) {
        this.viewCaseFile(datas[datas.length - 1], caseData);
      }
    }
  }

  showFinalReport(report: any, caseData: any) {
    if (typeof report === "object") {
      this.viewCaseFile(report.File, caseData);
    } else if (Array.isArray(report)) {
      // for (let i = 0; i < report.length; i++) {
      this.viewCaseFile(report[report.length - 1].File, caseData);
      // }
    }
  }

  viewCaseFile(report, caseData) {
    let location;
    if (caseData["ServiceProvider"].length > 0) {
      location = caseData["ServiceProvider"].find(
        (value) => value.Location.AccountType == "Laboratory"
      );
      if (location !== undefined) {
        location = location.Location;
      }
    } else {
      location = caseData["ServiceProvider"].Location;
    }

    let obj = {
      RequestID: report.PresentationData,
      Type: report.Category,
      RequestGUID: report.FileGUID,
      LabOrgGUID: location.OrganizationGUID,
      CaseGUID: caseData["CaseGUID"],
      DeploymentsKey: this.deploymentKey == undefined ? '' : this.deploymentKey,
    };
    this.ngxUiLoaderService.start();
    this.service.viewCases360DXReport(obj).subscribe(
      (data) => {
        this.ngxUiLoaderService.stop();
        if (
          data.StatusMessage !== null &&
          data.StatusMessage.toLowerCase() !== "failed"
        ) {
          if (data["FileContent"] !== null) {
            "data:application/pdf;base64," + data["FileContent"];
            let namemodal = {
              name: report.ReportName,
              fullfile: data["FileContent"],
            };
            this.service.auditsave(
              "View",
              "",
              "Viewed case360 dx report :-" + report.ReportName,
              "case",
              caseData["CaseGUID"],
              "Patient history tab ,deployment key :-" + this.deploymentKey
            );
            const modalRef = this.modalService.open(FileViewExplorerComponent, {
              windowClass: "myCustomModalViewfilecase360",
              backdrop: "static",
              keyboard: false,
            });
            modalRef.componentInstance.fileData = namemodal;
            this.currentModalRefs.push(modalRef);
            
            modalRef.result.then(() => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            }, (reason) => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            });
            
            // Add data attribute to identify the modal and backdrop
            this.modalTabVisibility.tagOwned('data-case360-modal', 'myCustomModalViewfilecase360');
            
            this.modalWasOpen = true;
          } else {
            this.ngxUiLoaderService.stop();
            this.toastr.warning("Data not Found", "Alert", {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            });
          }
        } else {
          this.ngxUiLoaderService.stop();
          if(data.FileContent !== null && data.FileContent !== "")
            {
            this.service.copyableToastError(data.FileContent,'Failed');
          }
          else{
          this.toastr.warning("Data not Found", "Alert", {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            });
          }
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
      }
    );
  }
  
  hideModals() {
  const result = this.modalTabVisibility.hideOwned('data-case360-modal', {
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
  this.modalWasOpen = result.modalWasOpen;
}

showModals() {
  this.modalTabVisibility.showOwned('data-case360-modal', {
    modalWasOpen: this.modalWasOpen,
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
}
}
